import { Injectable } from "@angular/core";
import { IServiceRequestTemplateResponse, IServiceRequestTemplateWithResults } from "@shared/interfaces/service-requests.interface";
import { ApiService } from "@shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ServiceRequestService {
  constructor(private api: ApiService) {}

  /**
   * Retrieves a service request by its id and language
   * @param id service request template id
   * @param lang language to display content
   * @return the service request
   */
  public getServiceRequestById(id: string, lang: string): Observable<IServiceRequestTemplateResponse> {
    return this.api.get(`service-requests/${encodeURIComponent(id)}`, { lang }, false) as Observable<IServiceRequestTemplateResponse>;
  }

  /**
   * Retrieves a service request with its result by its id and language
   * @param id service request template id
   * @param lang language to display content
   * @return the service request with its result
   */
  public getServiceRequestWithResults(id: string, lang: string): Observable<IServiceRequestTemplateWithResults> {
    return this.api.get(
      `service-requests/${encodeURIComponent(id)}/results`,
      { lang },
      true
    ) as Observable<IServiceRequestTemplateWithResults>;
  }

  /**
   * Marks a service request result as seen
   * @param id service request template id
   */
  public markResultAsSeen(id: string): Observable<void> {
    return this.api.post(`service-requests/results/${encodeURIComponent(id)}/seen`, {}, undefined, true) as Observable<void>;
  }
}
